<script lang="ts" context="module">
  export enum FormFieldLayout {
    FieldBelow,
    FieldRight,
    FieldLeft,
  }
</script>

<script lang="ts">
  export let label: string | undefined = undefined
  export let name: string
  export let error = ""
  export { className as class }

  export let layout: FormFieldLayout = FormFieldLayout.FieldBelow

  let className = ""
</script>

<div
  class="c-form-field flex justify-between {className}"
  class:flex-col={layout === FormFieldLayout.FieldBelow}
  class:flex-row={layout === FormFieldLayout.FieldRight}
  class:flex-row-reverse={layout === FormFieldLayout.FieldLeft}
  data-testid="form-field"
>
  {#if label || $$slots.label || $$slots.hint}
    <div class:mb-2={layout === FormFieldLayout.FieldBelow} class:mr-2={layout !== FormFieldLayout.FieldBelow}>
      {#if label || $$slots.label}
        <label
          for={name}
          class="c-form-field__label block font-semibold tracking-tight leading-tight"
          class:c-form-field__label--error={error}
          class:text-red-600={error}
        >
          {#if $$slots.label}
            <slot name="label" />
          {:else}
            {label}
          {/if}
        </label>
      {/if}

      {#if $$slots.hint}
        <div class="mt-0.5 text-neutral-800">
          <slot name="hint" />
        </div>
      {/if}

      {#if error && layout !== FormFieldLayout.FieldBelow}
        <p class="c-form-field__message c-form-field__message--error text-red-600 font-semibold mt-1 leading-tight">
          {error}
        </p>
      {/if}
    </div>
  {/if}

  <div class="c-form-field__control">
    <slot />
  </div>

  {#if error && layout === FormFieldLayout.FieldBelow}
    <p class="c-form-field__message c-form-field__message--error text-red-600 font-semibold mt-1 leading-tight">
      {error}
    </p>
  {/if}
</div>
